// URLs
// export const API_URI = 'https://taskschedulerapi20180518125042.azurewebsites.net/api/';
// export const API_URI = 'http://neurite-server:5000/api/';
// export const API_URI = 'https://localhost:5001/api/';
// export const API_URI = 'https://ilusionaapi20190307.azurewebsites.net/api/';
//export const API_URI = 'https://ilusionaapi-test.azurewebsites.net/api/';
// export const API_URI = 'https://3aguas-api.azurewebsites.net/api/';
// export const REPORTS_API_URI = 'http://localhost:65482/api/Reports';
// export const REPORTS_API_URI = 'https://neuritereportsapi.azurewebsites.net/api/Reports';
//export const REPORTS_API_URI = 'https://ilusiona-redemptionreports-prod.azurewebsites.net/api/Reports';
// export const REPORTS_API_URI = 'https://3aguas-reports-api.azurewebsites.net/api/Reports';
export const API_URI = () => {
    switch (process.env.REACT_APP_CLIENT) {
        case "3aguas-local":
            //return "https://localhost:5001/api/";
            return "https://3aguas-api.azurewebsites.net/api/";
        case "3aguas":
            return "https://3aguas-api.azurewebsites.net/api/";
        case "Ilusiona-local":
            //return "https://localhost:5001/api/";
            return "https://ilusiona-api-prod.azurewebsites.net/api/";
        case "Ilusiona":
            return "https://ilusiona-api-prod.azurewebsites.net/api/";
        default:
            break;
    }
}

export const REPORTS_API_URI = () => {
    switch (process.env.REACT_APP_CLIENT) {
        case "3aguas-local":
            return "https://3aguas-reports-api.azurewebsites.net/api/Reports";
        case "3aguas":
            return "https://3aguas-reports-api.azurewebsites.net/api/Reports";
        case "Ilusiona-local":
            // return "http://localhost:65482/api/Reports";
            return "https://ilusiona-redemptionreports-prod.azurewebsites.net/api/Reports";
            //return "https://neuritereportsapi.azurewebsites.net/api/Reports";
        case "Ilusiona":
            return "https://ilusiona-redemptionreports-prod.azurewebsites.net/api/Reports";
        default:
            break;
    }
}


// settings
export const AUTH = true;